export class Settings {
    constructor(
        public name: string,
        public headerVisible: boolean,
        public loadingSpinner: boolean,
        public showHeaderButtons: boolean,
        public rtl: boolean,
        public locale: string, 
        public firstDayOfWeek: number = 0
        ) { }
        
}
